import React from 'react';

import I18n from '../../../lib/i18n';
import NewsIcon from '../sharedUnpackeNewsComponents/NewsIcon';

interface IProps {
  newsIcon: string;
  topicName: string;
  publisher: string;
}

const OunceNewsHeader = (props: IProps) => (
  <div className="news-header">
    <NewsIcon newsIcon={props.newsIcon} />
    <div className="channel-box">
      <div className="channel-name">
        {props.topicName}
      </div>
      <div className="publisher-name-and-publishing-date">
        <div className="publisher-name">
          {props.publisher}
        </div>
        <div className="publishing-date">
          {I18n.locale == 'en' ? 'MM/DD/YYYY' : 'YYYY/MM/DD'}
        </div>
      </div>
    </div>
  </div>
);

export default OunceNewsHeader;
